<template>
    <div class="template" v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][bettyp]" :id="'test'+plytyp+'x'+bettyp">
      <div data-template="template0" class="wrap-template template0"> <!-- class 'is_rang' allbet clash -->
        <div class="main-handicap">
          <div class="vrow items-center template-title is_fold">
            <div class="play-name col" @click="showLeg()">
              <span class="ellipsis">{{ getTitleCaption() }}</span>
            </div>
            <div style="width: 37px;" @click="setToTop($event)">
              <span class="set_top" style="display: none;">
                <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
              </span>
            </div>
          </div>
          <template v-if="show">
            <div class="handicap">
              <div class="handicap-item m-oe os-1">
                <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item">
                        <!---->
                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                          <span class="ellipsis-wrap">{{ allBetEvent.tacapt }} {{ sportAllBetLang['ALL_BET.AND'] }} {{ sportAllBetLang['ALL_BET.LBL_YES'] }}</span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <odd1x2 :event="newAllBetEvent" :team="'ha'" :plyType="plytyp" :betType="bettyp" ref="teamha" :mode="'ab'" />
                    <!-- <div class="odds yb-number-font">
                      <div class="">
                        <span class="yb-family-odds yb-number-bold match_details">
                          <odd1x2 :event="newAllBetEvent" :team="'ha'" :plyType="plytyp" :betType="bettyp" ref="team2" :mode="'ab'" />
                        </span>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1">
                <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item">
                        <!---->
                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                          <span class="ellipsis-wrap">{{ allBetEvent.tacapt }} {{ sportAllBetLang['ALL_BET.AND'] }} {{ sportAllBetLang['ALL_BET.LBL_NO'] }}</span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <odd1x2 :event="newAllBetEvent" :team="'hb'" :plyType="plytyp" :betType="bettyp" ref="teamhb" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1">
                <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item">
                        <!---->
                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                          <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_DRAW']}} {{ sportAllBetLang['ALL_BET.AND'] }} {{ sportAllBetLang['ALL_BET.LBL_YES'] }}</span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <odd1x2 :event="newAllBetEvent" :team="'da'" :plyType="plytyp" :betType="bettyp" ref="teamda" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1">
                <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item">
                        <!---->
                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                          <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_DRAW']}} {{ sportAllBetLang['ALL_BET.AND'] }} {{ sportAllBetLang['ALL_BET.LBL_NO'] }}</span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <odd1x2 :event="newAllBetEvent" :team="'db'" :plyType="plytyp" :betType="bettyp" ref="teamdb" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1 no_border_bottom">
                <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item">
                        <!---->
                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                          <span class="ellipsis-wrap">{{ allBetEvent.tbcapt }} {{ sportAllBetLang['ALL_BET.AND'] }} {{ sportAllBetLang['ALL_BET.LBL_YES'] }}</span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <odd1x2 :event="newAllBetEvent" :team="'aa'" :plyType="plytyp" :betType="bettyp" ref="teamaa" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item m-oe os-1 no_border_bottom">
                <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item">
                        <!---->
                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                          <span class="ellipsis-wrap">{{ allBetEvent.tbcapt }} {{ sportAllBetLang['ALL_BET.AND'] }} {{ sportAllBetLang['ALL_BET.LBL_NO'] }}</span>
                          <span class="bet_handicap yb-family-odds"></span>
                        </div>
                      </div>
                    </div>
                    <odd1x2 :event="newAllBetEvent" :team="'ab'" :plyType="plytyp" :betType="bettyp" ref="teamab" :mode="'ab'" />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {
    mapGetters
  } from 'vuex'
  import OddComponents from '../../../components/odd'
  import HandicapComponents from '../../../components/handicap'
  
  import allBetMixin from '../../../mixins/allBet'
  
  export default {
    mixins: [allBetMixin],
    props: {
      allBetEvent: null,
      plytyp: null,
      bettyp: null,
      selectMarket: null,
      removeMarket: null,
      rbinfo: null,
      myMarket: {
        type: Boolean,
        default: false
      },
      isSpecial: {
        type: Boolean,
        default: false
      },
      mode:null
    },
    data() {
      return {
        btypes: [allBetMixin.data().onex2bttsBetType, allBetMixin.data().ronex2bttsBetType],
        show: true,
      }
    },
    computed: {
      ...mapGetters([
        'foldopenAllBet',
        'foldopenFirstEvent'
      ]),
      newAllBetEvent() {
        // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
        return this.allBetEvent
      },
    },
    watch: {
      foldopenAllBet() {
        if(this.mode=='ab'){
          this.show = (this.$store.getters.foldopenAllBet) ? true : false;
        }
      },
      foldopenFirstEvent() {
        if(this.mode!='ab'){
          this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
        }
      }
    },
    methods: {
      getTitleCaption() {
        var a = 'FT'
        var b = ''
        if (this.plytyp == this.firstHtPlyType) {
          a = '1H'
        }
  
        // if (this.bettype == this.hdpBetType) {
        b = this.sportAllBetLang['ALL_BET.SUBHEADER_1X2_BTTS']
        // } else if (this.bettype == this.bttsBetType) {
        //   b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_BTTS']
        // }
  
        // RB score
        // if (this.newAllBetEvent.event_rb == 1) {
        //   b += ' (' + this.newAllBetEvent.rbinfo.scoa + '-' + this.newAllBetEvent.rbinfo.scob + ')'
        // }
        return b
      },
      showLeg() {
        this.show = (!this.show) ? true : false;
      },
      setToTop(e) {
        this.$parent.setToTop(e);
      },
      addToMyMarket(plytyp, csBetType) {
        if (this.selectMarket)
          this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial)
      },
      removeFromMyMarket(plytyp, csBetType) {
        if (this.removeMarket)
          this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial)
      },
    },
    mounted(){
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }else{
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    },
  }
  </script>
  


// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/all-bet-1x2btts.vue